module.exports = __webpack_public_path__ + "img/flower-background.d2e136bb.png";